// Shared line-icon component for the modernized UI.
// Maps stable kebab-case names → lucide-react outline icons so screens and
// data tables (OPS_ALL, EMS_ALL, …) can reference an icon by name instead of
// importing components or hardcoding emoji. Bundles offline — safe for the
// future Capacitor wrap.
import {
  Route, ListChecks, Droplet, ArrowLeftRight, Calculator, Ruler, Gauge,
  Split, Waves, Truck, BookOpen, Siren, History, ClipboardList, Flame,
  Brain, Layers, Trophy, Mic, HeartPulse, Pill, Baby, Activity, Shield,
  GraduationCap, Home, Sun, Moon, LogIn, User, MessageSquare, Radio, Bell,
  Settings, Search, X, Check, Plus, Trash2, ChevronDown, ChevronRight,
  ArrowRight, MapPin, Wind, Lock, Pencil, CircleHelp, Box,
} from 'lucide-react';

const MAP = {
  // ── Pump Ops ──
  layout: Route, pc: ListChecks, supply: Droplet, relay: ArrowLeftRight,
  custom: Calculator, flref: Ruler, gpm: Gauge, multiline: Split,
  draft: Waves, apparatus: Truck, resources: BookOpen,
  // ── Command ──
  incident: Siren, history: History,
  // ── Training ──
  'training-hub': ClipboardList, evolutions: Flame, quiz: Brain,
  flashcards: Layers, leaderboard: Trophy, podcast: Mic, sim: Box,
  // ── EMS ──
  cprtimer: HeartPulse, drugcalc: Pill, assessment: ClipboardList,
  burncalc: Flame, pediatric: Baby, ecg: Activity,
  // ── Modes ──
  ops: Flame, command: Shield, training: GraduationCap, ems: HeartPulse,
  home: Home,
  // ── Chrome & misc ──
  chat: MessageSquare, radio: Radio, notices: Bell, sun: Sun, moon: Moon,
  login: LogIn, user: User, settings: Settings, search: Search,
  close: X, check: Check, add: Plus, trash: Trash2, chevron: ChevronDown,
  next: ChevronRight, arrow: ArrowRight, location: MapPin, wind: Wind,
  lock: Lock, edit: Pencil,
};

export function Icon({ name, size = 20, color = 'currentColor', strokeWidth = 2, style, className }) {
  const Cmp = MAP[name] || CircleHelp;
  return <Cmp size={size} color={color} strokeWidth={strokeWidth} style={style} className={className} aria-hidden="true" />;
}

export default Icon;
